// eslint-disable-next-line canonical/filename-match-regex
import { processFeatureData } from '../lib/featureData'
import { declOfNumber } from '../lib/numerals'
import { allowedStates } from './_variables'
import type { FinalData } from './load_data'
import type { Overlay } from 'ol'
import type Map from 'ol/Map'

const generatePlotInfo = (cls: string, title: string, content: string) => {
  let icon: string | undefined
  switch (cls) {
    case 'area':
      icon =
        '<svg viewBox="0 0 64 64" fill="currentColor"><path d="m54.32324 4h-34.01367a1 1 0 0 0 0 2h34.01367a3.68054 3.68054 0 0 1 3.67676 3.67627v34.01465a1 1 0 1 0 2 0v-34.01465a5.68315 5.68315 0 0 0 -5.67676-5.67627z"/><path d="m55.03027 48.94043a.99989.99989 0 1 0 -1.41406 1.41406l2.96961 2.96924h-42.23328a3.68033 3.68033 0 0 1 -3.67578-3.67627v-42.23328l2.96875 2.96912a.99989.99989 0 0 0 1.41406-1.41406l-4.67578-4.67624a.99963.99963 0 0 0 -1.41406 0l-4.67673 4.67624a.99989.99989 0 0 0 1.414 1.41406l2.96976-2.96936v42.23352a5.68231 5.68231 0 0 0 5.67578 5.67627h42.23328l-2.96961 2.96927a.99989.99989 0 1 0 1.41406 1.414l4.67673-4.67624a.99963.99963 0 0 0 0-1.41406z"/><path d="m21.7959 20.24512a.99973.99973 0 0 0 -1 1v19.416a1 1 0 0 0 2 0v-14.46581a3.23975 3.23975 0 0 1 6.47949 0v14.46582a1 1 0 0 0 2 0v-14.46582a3.23975 3.23975 0 0 1 6.47949 0v14.46582a1 1 0 0 0 2 0v-14.46582a5.22759 5.22759 0 0 0 -9.47943-3.05346 5.17192 5.17192 0 0 0 -7.47955-1.03241v-.86432a.99974.99974 0 0 0 -1-1z"/><path d="m50.27441 20.71436a3.8922 3.8922 0 0 0 .67286-2.18457 3.93409 3.93409 0 1 0 -7.86817 0 1 1 0 0 0 2 0 1.93409 1.93409 0 1 1 3.86817 0 1.87325 1.87325 0 0 1 -.30567 1.02978l-4.67773 5.021a1.38922 1.38922 0 0 0 1.01269 2.33886h4.87793a1 1 0 0 0 0-2h-3.46289l3.583-3.81054c.0264-.02832.29981-.39453.29981-.39453z"/></svg>'
      break
    case 'price-pers':
      icon =
        '<svg viewBox="0 0 511 511.99878" fill="currentColor"><path d="m512.398438 256.003906c0-2.933594-1.703126-5.59375-4.367188-6.816406l-131.21875-60.320312 131.21875-60.320313c5.683594-2.613281 5.6875-11.015625 0-13.628906l-248.5-114.234375c-2.046875-.9375-4.40625-.910156-6.425781.078125l-22.503907 11c-8.671874 4.238281-2.144531 17.738281 6.589844 13.476562l19.304688-9.4375 42.371094 19.476563-42.753907 19.65625-55.089843-25.25c-2.753907-1.261719-5.246094-2.375-8.253907-1l-188 86.234375c-5.6875 2.609375-5.695312 11.015625-.003906 13.628906l131.21875 60.324219-25.71875 11.820312c-8.773437 4.03125-2.558594 17.6875 6.265625 13.628906l37-17.007812c.132812-.058594.257812-.132812.382812-.199219l99.351563 45.667969c1.976563.910156 4.292969.910156 6.265625 0l99.324219-45.65625 128.085937 58.878906-230.542968 105.976563-230.546876-105.976563 50.4375-23.1875c8.773438-4.03125 2.566407-17.691406-6.261718-13.628906l-65.265625 30c-5.679688 2.613281-5.6875 11.015625 0 13.628906l131.222656 60.320313-131.222656 60.320312c-5.679688 2.613281-5.6875 11.015625 0 13.628907l248.503906 114.234374c1.972656.90625 4.292969.90625 6.265625 0l43-19.769531c8.769531-4.03125 2.566406-17.691406-6.265625-13.628906l-39.867187 18.328125-230.546876-105.976562 128.089844-58.882813 99.324219 45.660156c1.972656.90625 4.292969.90625 6.265625 0l99.773438-45.867187c.566406.527344 1.222656.976562 1.960937 1.316406l125.675781 57.769531-141.675781 65.128907c-8.773437 4.035156-2.558594 17.6875 6.265625 13.628906l156.5-71.941406c5.683594-2.613282 5.6875-11.015626 0-13.628907l-131.21875-60.320312 131.21875-60.320313c2.664062-1.222656 4.367188-3.882812 4.367188-6.8125zm-195.574219-56.070312-42.46875-19.523438 46.675781-21.457031 42.316406 19.59375zm-167.328125-21.363282 42.472656-19.523437 46.472656 21.363281-42.472656 19.523438zm-63.21875-29.058593 42.472656-19.523438 45.261719 20.804688-42.472657 19.523437zm47.496094-77.265625 42.183593 19.53125-47.207031 21.703125-42.390625-19.488281zm60.074218 27.816406 45.097656 20.882812-46.976562 21.59375-45.261719-20.804687zm232.667969-6.105469-42.5625 19.566407-46.542969-21.332032 42.632813-19.597656zm-60.539063 27.828125-44.921874 20.648438-46.304688-21.441406 44.683594-20.539063zm15.285157 48.527344-42.3125-19.59375 45.011719-20.691406 42.53125 19.492187zm-124.402344-57.605469-45.097656-20.878906 44.359375-20.394531 45.328125 20.777344zm-46.933594 38.085938 46.910157-21.566407 46.304687 21.441407-46.742187 21.488281zm234.542969-9.535157-42.535156-19.492187 42.539062-19.554687 42.46875 19.523437zm-127.644531-97.726562 45.261719 20.808594-42.660157 19.609375-45.328125-20.777344zm-122.953125 40.011719-42.164063-19.523438 44.101563-20.226562 42.328125 19.402343zm-125.484375 18.695312 42.40625 19.496094-42.472657 19.523437-42.453124-19.515624zm188.011719 125.472657-42.472657-19.523438 42.472657-19.523438 42.46875 19.523438zm0 0"/></svg>'
      break
    case 'price-total':
      icon =
        '<svg viewBox="0 0 128 128" fill="currentColor"><path d="m78.777 37.021a14.777 14.777 0 1 0 -14.777 14.779 14.795 14.795 0 0 0 14.777-14.779zm-26.054 0a11.277 11.277 0 1 1 11.277 11.279 11.29 11.29 0 0 1 -11.277-11.279z"/><path d="m123.328 121.069-14.266-37.4a1.751 1.751 0 0 0 -1.635-1.126h-27c.165-.269.329-.53.494-.8 10.389-17.2 15.617-32.246 15.542-44.714a32.464 32.464 0 0 0 -64.928-.011c-.075 12.479 5.153 27.527 15.542 44.725.165.273.329.534.494.8h-27a1.751 1.751 0 0 0 -1.635 1.126l-14.264 37.4a1.748 1.748 0 0 0 1.635 2.374h115.386a1.748 1.748 0 0 0 1.635-2.374zm-88.292-84.048a28.964 28.964 0 1 1 57.928.01c.15 24.858-23.09 55.517-28.964 62.869-5.874-7.349-29.115-38-28.964-62.879zm27.631 66.779a1.75 1.75 0 0 0 2.666 0 185.716 185.716 0 0 0 12.9-17.759h27.987l2.24 5.875-54.691 19.451-19.494-25.329h15.49a185.716 185.716 0 0 0 12.902 17.762zm-8.959 11.3h.01l32.627-11.6 12.655 16.443h-58.9zm-31.93-29.062h8.08l20.442 26.562-20.643 7.342h-20.81zm81.643 33.905-13.609-17.682 19.9-7.077 9.443 24.759z"/></svg>'
      break
    case 'kad':
    default:
      icon =
        '<svg viewBox="0 0 64 64" fill="currentColor"><path d="m59 18.30273h-11.73724l1.18744-10.42968a.99968.99968 0 0 0 -.87989-1.10694.98741.98741 0 0 0 -1.10644.88037l-1.2132 10.65625h-23.38244l1.18743-10.42968a.99967.99967 0 0 0 -.87988-1.10694.98477.98477 0 0 0 -1.10644.88037l-1.2132 10.65625h-9.33661a1.0002 1.0002 0 0 0 .00008 2h9.10881l-2.66352 23.39454h-11.9649a1.00013 1.00013 0 0 0 .00006 2h11.73718l-1.18744 10.42973a.9998.9998 0 0 0 1.98635.22649l1.21318-10.65617h23.38244l-1.18743 10.42968a.99972.99972 0 0 0 1.98632.22651l1.2132-10.65619h9.33661a1.0002 1.0002 0 0 0 -.00008-2h-9.10881l2.66352-23.39459h11.9649a1.00014 1.00014 0 0 0 0-2zm-16.64056 25.39454h-23.38244l2.66351-23.39454h23.38249z"/></svg>'
      break
  }

  return `<div class="plot-info plot-info--${cls}">
               <div class="icon">${icon}</div>
               <h4 class="plot-info__title">${title}:</h4>
               <div class="plot-info__content">${content}</div>
             </div>`
}

export const showPopup = (map: Map, $popup: JQuery<HTMLElement>, overlay: Overlay, data: FinalData) => {
  const $header = $popup.find('.map-popup__header-content')
  const $content = $popup.find('.map-popup__content')

  /**
   * Add a click handler to the map to render the popup.
   */
  // eslint-disable-next-line complexity
  map.on('singleclick', function (event_) {
    const feature = map.forEachFeatureAtPixel(event_.pixel, function (feature_) {
      if (feature_.get('type') === 'Special') {
        return null
      } else {
        return feature_
      }
    })

    if (feature) {
      const featureName = feature.get('name')
      const coordinate = event_.coordinate
      let popupHeader = ''
      let popupHTML = ''
      const processedFeature = processFeatureData(feature, data.plots[featureName])
      if (feature.get('type') === 'Entrance' && data.entrance?.gpsCoords) {
        popupHeader = '<h4 class="map-popup__title">Координаты:</h4>'
        popupHTML = `<p><a href="${encodeURI('geo:' + data.entrance.gpsCoords)}">${data.entrance.gpsCoords}</a></p>`
      } else {
        popupHeader = `<h3 class="map-popup__title">Участок №${featureName}</h3>`
        if (processedFeature.status) {
          popupHeader += `<div class="plot-status plot-status--${processedFeature.status.state}">
                                           ${processedFeature.status.name}
                                        </div>`
        }

        popupHTML = ''

        $content.removeClass(
          'map-popup__content--free map-popup__content--hold map-popup__content--sold map-popup__content--discount',
        )
        if (processedFeature.status) {
          $content.addClass('map-popup__content--' + processedFeature.status.state)
        }

        if (processedFeature.status?.state && allowedStates.includes(processedFeature.status.state)) {
          if (processedFeature.area) {
            const areaSotNumber = Math.floor(Number.parseFloat(processedFeature.area))
            const areaSot = declOfNumber(areaSotNumber, ['сотка', 'сотки', 'соток'])
            popupHTML += generatePlotInfo('area', 'Площадь', `${processedFeature.area}&nbsp;${areaSot}`)
          }

          if (
            processedFeature.status.state !== 'special' &&
            processedFeature.priceTotalNum &&
            processedFeature.priceTotalNum > 0
          ) {
            let content = processedFeature.priceTotalNum.toLocaleString() + '₽'
            if (processedFeature.priceTotalDiscountNum && processedFeature.priceTotalDiscountNum > 0) {
              content = `<s class="price-total__old">${content}</s> <span class="price-total__discounted">${processedFeature.priceTotalDiscountNum.toLocaleString() + '₽'}</span>`
            }

            popupHTML += generatePlotInfo('price-total', 'Цена за участок', content)
          }

          if (processedFeature.kad) {
            const coords = data.entrance?.gpsCoords
              ? data.entrance.gpsCoords.replace(' ', '')
              : '54.840333988445,37.86610789764049'
            const kadEncoded = encodeURIComponent(processedFeature.kad)
            const cadURI = `https://pkk.rosreestr.ru/#/search/${coords}/16/@1b4ulz5wfl?text=${kadEncoded}&opened=${kadEncoded}`
            popupHTML += generatePlotInfo(
              'kad',
              'Кадастровый номер',
              `<a href="${cadURI}" target="_blank" rel="noopener noreferrer">${processedFeature.kad}</a>`,
            )
          }

          if (
            processedFeature.status.state !== 'special' &&
            processedFeature.pricePerNum &&
            processedFeature.pricePerNum > 0
          ) {
            let content = processedFeature.pricePerNum.toLocaleString() + '₽'
            if (processedFeature.pricePerDiscountNum && processedFeature.pricePerDiscountNum > 0) {
              content = `<s class="price-pers__old">${content}</s> <span class="price-pers__discounted">${processedFeature.pricePerDiscountNum.toLocaleString() + '₽'}</span>`
            }

            popupHTML += generatePlotInfo('price-pers', 'Цена за сотку', content)
          }

          if (processedFeature.status.state === 'special' && processedFeature.field_link_to_special_export) {
            popupHTML += `<div class="plot-info plot-info--special">
                                           <a class="btn btn-round btn-primary" href="${processedFeature.field_link_to_special_export}">Перейти к спецпредложению</a>
                                         </div>`
          }
        }
      }

      $header.html(popupHeader)
      $content.html(popupHTML)
      if (
        processedFeature.status &&
        (processedFeature.status.state === 'free' ||
          processedFeature.status.state === 'hold' ||
          processedFeature.status.state === 'discount' ||
          processedFeature.status.state === 'mortgage')
      ) {
        // Берём webform «Записаться на просмотр» со страницы и клонируем в момент клика,
        // чтобы оригинал остался работать под картой.
        const $source = jQuery('form[id^="webform-submission-zapisatsya-na-prosmotr"]').first()
        if ($source.length > 0) {
          const $form = $source.clone()
          $form.removeAttr('data-once')
          // id формы НЕ убираем, только разводим суффиксом: цель Метрики в ym.ts
          // ищется по form.id.startsWith('webform-submission-zapisatsya-na-prosmotr'),
          // и без префикса заявка с карты не засчиталась бы как конверсия.
          const sourceFormId = $source.attr('id')
          if (sourceFormId) {
            $form.attr('id', `${sourceFormId}--map`)
          }

          // clone() копирует defaultValue из разметки, а не текущее значение поля.
          // Скрытые utm_* заполняет скрипт уже после загрузки страницы, поэтому у клона
          // они были бы пустыми — переносим значения вручную.
          const sourceFields = $source.find('input, select, textarea').toArray()
          const clonedFields = $form.find('input, select, textarea').toArray()
          for (const [index, sourceField] of sourceFields.entries()) {
            const clonedField = clonedFields[index]
            if (!clonedField) {
              continue
            }

            const source = sourceField as HTMLInputElement
            const cloned = clonedField as HTMLInputElement
            if (source.type === 'checkbox' || source.type === 'radio') {
              cloned.checked = source.checked
            } else {
              cloned.value = source.value
            }
          }

          // Drupal сам разводит id второй формы на странице, clone() — нет.
          // Без этого <label for="edit-name"> из попапа фокусирует поле формы под картой.
          for (const element of $form.find('[id]').toArray()) {
            element.id = `${element.id}--map`
          }

          for (const element of $form.find('label[for]').toArray()) {
            const label = element as HTMLLabelElement
            label.htmlFor = `${label.htmlFor}--map`
          }

          const posyolok = jQuery('#main-content .paragraph--type--paragraph-header-block h1').text()
          $form.find('input[name="posyolok"]').val(posyolok)
          $form.find('input[name="nomer_uchastka"]').val(featureName)
          $form.append(
            '<a href="/ipoteka" class="btn btn--ipoteka" target="_blank">Купить участок в ипотеку</a>' +
              '<a href="/postroim-dom" class="btn" target="_blank">Заказать постройку дома</a>',
          )
          $content.append($form)
        }
      }

      overlay.setPosition(coordinate)
    } else {
      $header.html('')
      $content.html('')
      overlay.setPosition(undefined)
    }
  })
}
